import { render, staticRenderFns } from "./SnapshotsGallery.vue?vue&type=template&id=37fbe2f8&scoped=true"
import script from "./SnapshotsGallery.vue?vue&type=script&lang=js"
export * from "./SnapshotsGallery.vue?vue&type=script&lang=js"
import style0 from "./SnapshotsGallery.vue?vue&type=style&index=0&id=37fbe2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fbe2f8",
  null
  
)

export default component.exports